import moment from "moment";
import { useCallback, useRef, useState } from "react";

import { useReactToPrint } from "react-to-print";
import { Spinner } from "reactstrap";

export const ButtonPrintBatasanHargaJualRumah = ({ innerRef, title }) => {
  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);

  const reactToPrintContent = useCallback(() => {
    return innerRef.current;
  }, [innerRef]);

  const handleAfterPrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);
    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: title,
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  return (
    <button
      type="submit"
      className="btn btn-item"
      onClick={() => {
        handlePrint();
      }}
    >
      CETAK &nbsp;{loadingPrint ? <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"></Spinner> : ""}
    </button>
  );
};

export const PrintDocBatasanHargaJualRumah = ({ innerRef, item, companyName, companyValue }) => {
  const handleValidDate = (date) => {
    return moment(date).format("MMM D, YYYY");
  };

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  return item === undefined || item === null ? (
    <></>
  ) : (
    <div
      className="d-none"
      style={{
        overflow: "scroll",
        //backgroundColor: "blue"
      }}
    >
      <div ref={innerRef} className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
        <div
          style={{
            textAlign: "center",
            fontSize: "18px",
            fontWeight: "bold",
          }}
        >
          BATASAN HARGA JUAL RUMAH UMUM TAPAK <br />
          DAN SATUAN RUMAH SUSUN UMUM
        </div>

        <div style={{ padding: "10px" }}>
          <ol style={{ paddingLeft: "15px" }}>
            <li>
              Rumah Umum Tapak
              <br />{" "}
              <table style={{ borderCollapse: "collapse", width: "100%", maxWidth: "950px", margin: "0 auto" }}>
                <tbody>
                  {/* A */}
                  <tr>
                    <td
                      style={{
                        width: "60px",
                        border: "1px solid #000",
                        padding: "6px 8px",
                        fontWeight: "bold",
                        textAlign: "center",
                      }}
                    >
                      NO
                    </td>
                    <td
                      style={{
                        border: "1px solid #000",
                        padding: "6px 8px",
                        fontWeight: "bold",
                      }}
                    >
                      WILAYAH
                    </td>
                    <td
                      style={{
                        border: "1px solid #000",
                        padding: "6px 8px",
                        fontWeight: "bold",
                      }}
                    >
                      HARGA JUAL PALING BANYAK 2024 (Rp)
                    </td>
                  </tr>
                  <tr>
                    <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "center" }}>1.</td>
                    <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Jawa (kecuali Jakarta, Bogor, Depok, Tangerang, Bekasi) dan Sumatera (kecuali Kep. Riau, Bangka Belitung, Kepulauan Mentawai)</td>
                    <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top" }}>166.000.000</td>
                  </tr>
                  <tr>
                    <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "center" }}>2.</td>
                    <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Kalimantan (kecuali Kabupaten Murung Raya dan Kabupaten Mahakam Ulu)</td>
                    <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top" }}>182.000.000</td>
                  </tr>
                  <tr>
                    <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "center" }}>3.</td>
                    <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Sulawesi, Bangka Belitung, Kepulauan Mentawai, dan Kepulauan Riau (kecuali Kepulauan Anambas)</td>
                    <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top" }}>173.000.000</td>
                  </tr>
                  <tr>
                    <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "center" }}>4.</td>
                    <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Maluku, Maluku Utara, Bali dan Nusa Tenggara, Jabodetabek (Jakarta, Bogor,Depok, Tangerang, Bekasi), Kepulauan Anambas, Kabupaten Murung Raya, dan Kabupaten Mahakam Ulu</td>
                    <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top" }}>185.000.000</td>
                  </tr>
                  <tr>
                    <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top", textAlign: "center" }}>5.</td>
                    <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Papua dan Papua Barat</td>
                    <td style={{ border: "1px solid #000", padding: "4px 8px", verticalAlign: "top" }}>240.000.000</td>
                  </tr>
                </tbody>
              </table>
            </li>
            <li>
              Satuan Rumah Susun Umum
              <ol type="a" style={{ paddingLeft: "24px" }}>
                <li>
                  Provinsi
                  <br />{" "}
                  <table style={{ borderCollapse: "collapse", width: "100%", maxWidth: "950px", margin: "0 auto" }}>
                    <tbody>
                      <tr>
                        <td
                          style={{
                            width: "60px",
                            border: "1px solid #000",
                            padding: "6px 8px",
                            fontWeight: "bold",
                            textAlign: "center",
                          }}
                        >
                          NO
                        </td>
                        <td
                          style={{
                            border: "1px solid #000",
                            padding: "6px 8px",
                            fontWeight: "bold",
                          }}
                        >
                          WILAYAH
                        </td>
                        <td
                          style={{
                            border: "1px solid #000",
                            padding: "6px 8px",
                            fontWeight: "bold",
                          }}
                        >
                          HARGA JUAL/m2 PALING BANYAK (Rp)
                        </td>
                        <td
                          style={{
                            border: "1px solid #000",
                            padding: "6px 8px",
                            fontWeight: "bold",
                          }}
                        >
                          HARGA JUAL PALING BANYAK (Rp)
                        </td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>1</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Nanggroe Aceh Darussalam</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>8.500.000</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>306.000.000</td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>2</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Sumatera Utara</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>7.800.000</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>280.800.000</td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>3</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Sumatera Barat</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>8.800.000</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>316.800.000</td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>4</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Riau</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>9.500.000</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>342.000.000</td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>5</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Kepulauan Riau</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>10.000.000</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>360.000.000</td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>6</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Jambi</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>8.800.000</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>316.800.000</td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>7</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Bengkulu</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>8.000.000</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>288.000.000</td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>8</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Sumatera Selatan</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>8.700.000</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>313.200.000</td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>9</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Bangka Belitung</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>8.900.000</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>320.400.000</td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>10</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Lampung</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>8.000.000</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>288.400.000</td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>11</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Banten (kecuali Kota/Kabupaten Tangerang dan Kota Tangerang Selatan)</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>7.600.000</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>273.600.000</td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>12</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Jawa Barat (kecuali Kota Depok, Kota/Kabupaten Bogor, dan Kota/Kabupaten Bekasi)</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>7.300.000</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>262.800.000</td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>13</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Jawa Tengah</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>7.200.000</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>259.200.000</td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>14</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Daerah Istimewa Yogyakarta</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>7.300.000</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>262.800.000</td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>15</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Jawa Timur</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>7.900.000</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>284.400.000</td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>16</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Bali</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>8.300.000</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>298.800.000</td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>17</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Nusa Tenggara Barat</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>7.400.000</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>266.400.000</td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>18</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Nusa Tenggara Timur</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>8.600.000</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>309.600.000</td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>19</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Kalimantan Barat</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>9.700.000</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>349.200.000</td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>20</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Kalimantan Tengah</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>9.400.000</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>338.400.000</td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>21</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Kalimantan Utara</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>9.800.000</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>352.800.000</td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>22</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Kalimantan Timur</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>9.900.000</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>356.000.000</td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>23</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Kalimantan Selatan</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>9.000.000</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>324.400.000</td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>24</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Sulawesi Utara</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>7.800.000</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>280.800.000</td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>25</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Gorontalo</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>8.300.000</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>298.800.000</td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>26</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Sulawesi Tengah</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>6.900.000</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>248.400.000</td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>27</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Sulawesi Tenggara</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>8.200.000</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>295.200.000</td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>28</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Sulawesi Barat</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>8.700.000</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>313.200.000</td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>29</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Sulawesi Selatan</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>7.300.000</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>262.800.000</td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>30</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Maluku</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>7.600.000</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>273.600.000</td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>31</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Maluku Utara</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>9.600.000</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>345.600.000</td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>32</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Papua</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>15.700.000</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>565.200.000</td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>33</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Provinsi Papua Barat</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>10.700.000</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>385.200.000</td>
                      </tr>
                    </tbody>
                  </table>
                </li>
                <li>
                  Kota/Kabupaten
                  <br />{" "}
                  <table style={{ borderCollapse: "collapse", width: "100%", maxWidth: "950px", margin: "0 auto" }}>
                    <tbody>
                      <tr>
                        <td
                          style={{
                            width: "60px",
                            border: "1px solid #000",
                            padding: "6px 8px",
                            fontWeight: "bold",
                            textAlign: "center",
                          }}
                        >
                          NO
                        </td>
                        <td
                          style={{
                            border: "1px solid #000",
                            padding: "6px 8px",
                            fontWeight: "bold",
                          }}
                        >
                          WILAYAH
                        </td>
                        <td
                          style={{
                            border: "1px solid #000",
                            padding: "6px 8px",
                            fontWeight: "bold",
                          }}
                        >
                          HARGA JUAL/m2 PALING BANYAK (Rp)
                        </td>
                        <td
                          style={{
                            border: "1px solid #000",
                            padding: "6px 8px",
                            fontWeight: "bold",
                          }}
                        >
                          HARGA JUAL PALING BANYAK (Rp)
                        </td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>1</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Kota Jakarta Barat</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>8.900.000</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>320.400.000</td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>2</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Kota Jakarta Selatan</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>9.200.000</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>331.200.000</td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>3</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Kota Jakarta Timur</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>8.800.000</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>316.800.000</td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>4</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Kota Jakarta Utara</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>9.600.000</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>345.600.000</td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>5</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Kota Jakarta Pusat</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>9.300.000</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>334.800.000</td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>6</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Kota/Kabupaten Tangerang dan Kota Tangerang Selatan</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>8.400.000</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>302.400.000</td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>7</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Kota Depok</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>8.500.000</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>306.000.000</td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>8</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Kota/Kabupaten Bogor</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>8.600.000</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>309.600.000</td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>9</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px" }}>Kota/Kabupaten Bekasi</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>8.400.000</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "right" }}>302.400.000</td>
                      </tr>
                    </tbody>
                  </table>
                </li>
              </ol>
            </li>
          </ol>
        </div>
      </div>
    </div>
  );
};
